import { render, staticRenderFns } from "./AdherenceIndicatorsGDI.vue?vue&type=template&id=45614c24&scoped=true&"
import script from "./AdherenceIndicatorsGDI.vue?vue&type=script&lang=js&"
export * from "./AdherenceIndicatorsGDI.vue?vue&type=script&lang=js&"
import style0 from "./AdherenceIndicatorsGDI.vue?vue&type=style&index=0&id=45614c24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45614c24",
  null
  
)

export default component.exports